import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, of} from 'rxjs';
import { map, take, toArray } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InfinitScrollService {
  lastVisible;
  firstCol;

  firstItems;
  nextItems;
  lastDoc;

  constructor(
    private db: AngularFirestore,
    //private fs: firestore
  ) {}

  
  firstList(colName){
     return this.db.collection(colName, ref=> ref 
      .where("publish", "==", true)
      .orderBy('name')
      .limit(15)      
    )
  }

  nextList(colName, lastDoc){
    //console.log(`nextList() this.lastDoc: ${this.lastDoc}`);
    return this.db.collection(colName, ref=> ref
    .where("publish", "==", true)
    .orderBy('name')
    .startAfter(lastDoc)
    .limit(10)
    )
  }
  
}